<div class="nav-items-container">
  <ng-content />
</div>
